@if (showLoader) {
  <div class="loader dynamic-loader">
    <!--img src="/assets/css/images/platform/loader.gif" />-->
    <sem-loader [showLoader]="true"></sem-loader>
  </div>
}
<div #vc></div>